module.exports = __webpack_public_path__ + "media/images/haircut/card-desktop@2x-333839b447a07bf23dcde1349ec5f7ea.jpg";